// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"652":"4723469c","2549":"3b53517f","4775":"3b53517f"}[chunkId] + ".chunk.css";
};